/**
 * @generated SignedSource<<1a35ba3fa0869acda1fdb4635042ae30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment$data = {
  readonly classificationLevel: {
    readonly color: {
      readonly colorKey: string | null | undefined;
    } | null | undefined;
    readonly guidelines: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment";
};
export type ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment$key = {
  readonly " $data"?: ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueClassificationBadge_IssueClassificationBadgeOld_dataClassificationFragment",
  "selections": [
    {
      "concreteType": "JiraClassificationLevel",
      "kind": "LinkedField",
      "name": "classificationLevel",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraColor",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "colorKey"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "guidelines"
        }
      ]
    }
  ],
  "type": "JiraDataClassificationField"
};

(node as any).hash = "3635dc15e77182665a88e2994fd97a81";

export default node;
